import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddEditFlagModalComponent } from '../add-edit-flag-modal/add-edit-flag-modal.component';
import { take } from 'rxjs/operators';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';
import { FeatureFlagUI } from 'src/app/domains/feature-flags/models/feature-flags.model';
import { FeatureFlagsService } from 'src/app/domains/feature-flags/services';
import { FlagUsageModalComponent } from '../flag-usage-modal/flag-usage-modal.component';

@Component({
  selector: 'gdp-feature-flags-table',
  templateUrl: './feature-flags-table.component.html'
})
export class FeatureFlagsTableComponent {
  private readonly modalService: NgbModal = inject(NgbModal);
  private readonly notification: NotificationService = inject(NotificationService);
  private readonly featureFlagsService: FeatureFlagsService = inject(FeatureFlagsService);
  public _loading: boolean = false;
  @Output() onFlagEdit: EventEmitter<void> = new EventEmitter<void>();
  @Output() onFlagDelete: EventEmitter<void> = new EventEmitter<void>();
  @Input() set loading(value: boolean) {
    this._loading = value;
  };
  @Input() flags: FeatureFlagUI[] = [];

  private openEditModal(flag: FeatureFlagUI) {
    const modal = this.modalService.open(AddEditFlagModalComponent, { size: 'lg' });
    const editableFlag: FeatureFlagUI = {
      ...flag,
      isEditing: true
    } 
    Object.assign(modal.componentInstance, {
      title: 'internal-facilities.feature-flags.add-edit-modal.edit.title',
      flag: editableFlag,
      flags: this.flags
    });
    modal.componentInstance.onFlagSubmit.pipe(take(1)).subscribe({
      next: () => {
        this.onFlagEdit.emit();
      }
    });
  }

  public updateFlag(flag: FeatureFlagUI) {
    this.openEditModal(flag)
  }

  public deleteFlag(flag: FeatureFlagUI, id: number) {
    flag.loading = true;
    this.notification.showConfirmationWithParams(
      'internal-facilities.feature-flags.confirm-delete', 
      { flag: flag.key }
    ).then((result: string) => {
      if (result === 'ok') {
        this.featureFlagsService.deleteFeatureFlag(id).subscribe({
          next: () => {
            flag.loading = false;
            const currentIndex = this.flags.findIndex((item) => item.id === id);
            if (currentIndex !== -1) {
              this.flags.splice(currentIndex, 1);
            }
            this.onFlagDelete.emit();
          },
          error: () => {
            flag.loading = false;
          }
        })
      } else {
        flag.loading = false;
      }
    }, () => {
      flag.loading = false;
    })
  }
  
  // @coderabbitai ignore:start
  public showFlagUsage(_flag: FeatureFlagUI) {
    const modal = this.modalService.open(FlagUsageModalComponent, {size: 'xl'})
    Object.assign(modal.componentInstance, {
      flagId: _flag.id
    });
  }
  // @coderabbitai ignore:end
}
